import {
  generateAnonymousUserContext,
  generateUserContext,
  type LaunchDarklyContext,
} from '@sg/launch-darkly';

import { APP_CONTEXT, legacy_CUSTOM_ATTRIBUTES } from './useLaunchDarklyIntegration.constants';
import { type Customer } from './useLaunchDarklyIntegration.types';

// ─────────────────────────────────────────────────────────────────────────────

export function generateInitialContext(customer: Customer) {
  return {
    user: generateCustomerContext(customer),
    app: APP_CONTEXT,
  } satisfies Record<string, LaunchDarklyContext>;
}

function generateCustomerContext(customer: Customer): LaunchDarklyContext {
  const customerId = customer.id;

  if (customerId) {
    return {
      ...generateUserContext({ customer: { ...customer, id: customerId } }),
      ...legacy_CUSTOM_ATTRIBUTES,
    };
  }

  return {
    anonymous: true,
    ...generateAnonymousUserContext(),
    ...legacy_CUSTOM_ATTRIBUTES,
  };
}
